export const SignatureApi = Symbol('SignatureApi')

export interface SignatureApi {
    getSignaturedPath(params: {
        sign_type: string
        object_key: string[]
        content_type?: string
    }): Promise<Record<string, string>>
}
